import { accountApplicationWebSocketService } from '../classes/AccountApplicationWebSocketService';
import { webSocketService } from '../classes/WebSocketService';
import { getAccountApplicationUpdateSubscriptionCmd } from '../services/WebSocket';
import { useFeatureFlag } from '@tradingblock/components';

export const useAccountApplicationsWebSocket = () => {
  const { isEnabled: useLofiAccountApplications } = useFeatureFlag('lofi-account-applications');

  const trySend = (cmd?: string): { success: boolean } => {
    try {
      if (cmd) {
        const response = accountApplicationWebSocketService.sendMessage(cmd);
        return response.success ? { success: true } : { success: false };
      }
      return { success: false };
    } catch (error) {
      console.error(`Error trying to send WebSocket cmd ${cmd}: ${error}`);
      return { success: false };
    }
  };

  const trySendToOldWebSocket = (cmd?: string): { success: boolean } => {
    try {
      if (cmd) {
        const response = webSocketService.sendMessage(cmd);
        return response.success ? { success: true } : { success: false };
      }
      return { success: false };
    } catch (error) {
      console.error(`Error trying to send WebSocket cmd ${cmd}: ${error}`);
      return { success: false };
    }
  }


  const subscribeToAccountApplicationUpdates = (accountId: number | string, apiToken: string): { success: boolean } => {
    if (useLofiAccountApplications) {
      const parsedAccountId: number = typeof accountId === 'string' ? parseInt(accountId) : accountId;
      const request = {
        type: 'Subscribe',
        accountId: parsedAccountId,
      };
      const cmd = JSON.stringify(request);
      return trySend(cmd);
    } else {
      const cmd = getAccountApplicationUpdateSubscriptionCmd(accountId, apiToken);
      return trySendToOldWebSocket(cmd);
    }

  };

  const unsubscribeFromAccountApplicationUpdates = (accountId: string | number, apiToken: string): { success: boolean } => {
    if (useLofiAccountApplications) {
      const parsedAccountId: number = typeof accountId === 'string' ? parseInt(accountId) : accountId;
      const request = {
        type: 'Unsubscribe',
        accountId: parsedAccountId,
      };
      const cmd = JSON.stringify(request);
      return trySend(cmd);
    } else {
      const cmd = getAccountApplicationUpdateSubscriptionCmd(accountId, apiToken, true);
      return trySendToOldWebSocket(cmd);
    }
  };

  return {
    subscribeToAccountApplicationUpdates,
    unsubscribeFromAccountApplicationUpdates,
  };
};
